import React, { useContext } from 'react';
import bookmarkIcon from '../../../../../assets/bookmark.svg';
import bookmarkIconFilled from '../../../../../assets/bookmark-filled.svg';
import './feature-article-card-bookmark-icon.scss';
import { BookmarkContext } from '../../../../../views/dyf-landing-view/context/dyf-bookmark-context';
import { UiFeature } from '../../../../../hooks/dyf/use-your-vehicle-features/vehicle-features.types';

interface FeatureArticleCardBookmarkIconProps {
    item: UiFeature;
    bookmarkAriaLabel: string;
}

export const FeatureArticleCardBookmarkIcon: React.FC<FeatureArticleCardBookmarkIconProps> = ({
    item,
    bookmarkAriaLabel,
}) => {
    const { onBookmarkIconClick, isBookmarkedFeature } = useContext(
        BookmarkContext
    );

    const handleOnClick = () => {
        onBookmarkIconClick(item);
    };

    return (
        <div
            data-testid="bookmark-icon"
            className="bookmark-img"
            onClick={() => handleOnClick()}
        >
            <img
                src={
                    isBookmarkedFeature(`${item.topicId}`)
                        ? bookmarkIconFilled
                        : bookmarkIcon
                }
                alt={bookmarkAriaLabel}
            />
        </div>
    );
};
